import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class AdminUsersApi {
  static getAdminUsers = () => {
    return axios.get(`${API_BASE_URL}/admin/users`);
  };

  static getAdminUser = (username) => {
    return axios.get(
      `${API_BASE_URL}/admin/user/${encodeURIComponent(username)}`,
    );
  };

  static createAdminUser = (data) => {
    return axios.post(`${API_BASE_URL}/admin/user`, data);
  };

  static updateAdminUser = (data) => {
    return axios.put(`${API_BASE_URL}/admin/user`, data);
  };

  static deleteAdminUser = (username) => {
    return axios.delete(
      `${API_BASE_URL}/admin/user/${encodeURIComponent(username)}`,
    );
  };

  static resendActivationEmail = (data) => {
    return axios.post(
      `${API_BASE_URL}/admin/user/resend_activation_email`,
      data,
    );
  };

  static toggleAdminUser = (username, deactivateUser) => {
    return axios.put(`${API_BASE_URL}/admin/user/toggle`, {
      username,
      deactivateUser,
    });
  };
}
